import { ThemeConfig } from 'antd/es/config-provider/context'

export const variables: Record<string, ThemeConfig> = {
  dark: {
    token: {
      colorText: '#fff',
    },
    components: {
      Button: {
        colorText: '#000',
      },
      Card: {
        headerBg: '#2c2c2c',
        colorBgContainer: '#000',
        colorTextHeading: '#fff',
        colorPrimary: 'blue',
      },
      Statistic: {
        colorTextDescription: '#fff',
      },
      Divider: {
        colorSplit: '#f3f3f3',
      },
      List: {
        colorTextDescription: '#fff',
      },
    },
  },
  light: {
    token: {
      fontFamily: 'inherit',
      borderRadius: 10,
      colorLink: 'rgba(122, 114, 255, 1)',
      colorPrimary: 'rgba(122, 114, 255, 1)',
      colorPrimaryActive: 'rgba(122, 114, 255, 1)',
      colorPrimaryHover: 'rgba(122, 114, 255, 1)',
    },
    components: {
      Button: {
        controlHeightLG: 56,
        borderRadiusLG: 16,
        primaryShadow: 'none',
        contentFontSizeLG: 17,
        borderColorDisabled: 'transparent',
        colorPrimary: 'rgba(122, 114, 255, 1)',
        colorPrimaryHover: 'rgba(122, 114, 255, 1)',
        colorPrimaryActive: 'rgba(122, 114, 255, 1)',
        colorPrimaryBorder: 'rgba(122, 114, 255, 1)',
        colorLink: 'rgba(122, 114, 255, 1)',
        colorLinkActive: 'rgba(122, 114, 255, 1)',
        colorLinkHover: 'rgba(122, 114, 255, 1)',
      },
      Card: {
        headerBg: '#f3f3f3',
        colorBgContainer: '#fff',
        colorTextHeading: '#000',
        colorPrimary: 'red',
      },
      Checkbox: {
        colorText: 'var(--textPrimary)',
        colorPrimary: 'var(--bgAccent)',
        colorPrimaryBorder: 'var(--bgAccent)',
        colorPrimaryHover: 'var(--bgAccent)',
        colorBorder: 'var(--bgSecondaryActive)',
        colorBgContainer: 'var(--bgPrimaryDisabled)',
        colorBgContainerDisabled: 'var(--bgAccent)',
        controlItemBgActiveDisabled: 'var(--bgAccent)',
        controlInteractiveSize: 24,
        borderRadiusSM: 8,
        fontSize: 15,
      },
      Input: {
        inputFontSize: 16,
        activeBorderColor: 'var(--bgAccent)',
        hoverBorderColor: 'var(--bgAccent)',
      },
      Segmented: {
        itemActiveBg: 'var(--bgAccent)',
        itemSelectedBg: 'var(--bgAccent)',
        itemColor: 'rgba(5, 5, 16, 1)',
        trackBg: 'rgba(5, 5, 16, 0.08)',
        itemSelectedColor: '#fff',
      },
    },
  },
}
